<template>
  <div class="selfPriceTable">
    <el-form ref="formTool" :inline="true" style="text-align: left">
      <el-table
        v-loading="loading"
        :span-method="
          ({ row, column, rowIndex, columnIndex }) =>
            objectSpanMethod({ row, column, rowIndex, columnIndex }, areaData)
        "
        :data="areaData"
        style="width: 100%"
      >
        <el-table-column label="省级组织" width="140px" fixed>
          <template slot-scope="scope">
            <div style="text-align: center; margin-bottom: 10px">
              <span>{{ provinceOrgName }}</span>
            </div>
            <el-radio-group v-model="kbSwitchFlag">
              <el-radio :label="0" style="margin-bottom: 5px"
                >资金自动分流</el-radio
              >
              <el-radio :label="1">指定账户分账</el-radio>
            </el-radio-group>
            <div ><el-button size="mini" type="primary" @click="createLedgerRules">创建规则</el-button></div>
          </template>
        </el-table-column>

        <el-table-column label="地级组织" prop="orgName" width="180" fixed>
        </el-table-column>
        <el-table-column label="所属医药公司" prop="shopName" width="220" fixed>
        </el-table-column>
        <el-table-column label="医药公司创建商品" prop="" width="140">
          <template slot-scope="scope">
            <div class="status_img" v-if="scope.row.goodsSkuPriceId">
              <img src="@/assets/success.png" alt="" />
            </div>
            <div class="status_img" v-if="!scope.row.goodsSkuPriceId">
              <img src="@/assets/reject.png" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="销售定价" prop="price" width="170">
          <template slot-scope="scope">
            <div class="unit-box">
              <span
                ><el-input
                  :disabled="scope.row.status == 'PUTAWAY' ? true : false"
                  v-model="scope.row.price"
                  class="tag-input"
                  style="width: 100px"
                  size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                >
                  <template slot="prefix">
                    <span
                      class="unitY"
                      :style="
                        scope.row.status == 'PUTAWAY'
                          ? 'color:#8c8c8c'
                          : 'color:#606266'
                      "
                      >￥</span
                    >
                  </template>
                </el-input></span
              >
              <span @click="openDaliog(scope.row, scope.$index)" class="unit-s">
                <el-tag type="primary" size="medium">
                  {{ scope.row.goodsSkuUnit }}</el-tag
                >
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="合作医药公司名称" prop="shopName" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              disabled
              v-model="scope.row.shopName"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 1);
                }
              "
            >
              <el-option
                v-for="item in medicineManager"
                :key="item.shopId"
                :label="item.shopName"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="医药公司康贝" prop="merchantNo" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              :disabled="scope.row.status == 'PUTAWAY' ? true : false"
              v-model="scope.row.merchantNo"
              @visible-change="
                (val) => {
                  getListByShopIdFn(val, scope.row.shopId, 1);
                }
              "
            >
              <el-option
                v-for="(item, key) in listByShopId"
                :key="key"
                :label="item.merchantNo"
                :value="item.merchantNo"
              >
                <span style="color: #8492a6; font-size: 13px"
                  >康贝号: {{ item.merchantNo }}</span
                >
                <span> {{ item.merchantName }}</span>
                <!-- <span  > 结算金额: {{ item.money }}</span>   -->
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="销售金额" prop="amount" width="140">
          <template slot-scope="scope">
            <div class="unit-box">
              <span>
                <el-input
                  :disabled="scope.row.status == 'PUTAWAY' ? true : false"
                  v-model="scope.row.amount"
                  class="tag-input"
                  style="width: 100px"
                  size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                >
                  <template slot="prefix">
                    <span
                      class="unitY"
                      :style="
                        scope.row.status == 'PUTAWAY'
                          ? 'color:#8c8c8c'
                          : 'color:#606266'
                      "
                      >￥</span
                    >
                  </template>
                </el-input>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="地区公司名称" prop="city_shopName" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              clearable
              v-model="scope.row.city_shopName"
              @clear="clearTips(scope.row, scope.$index)"
              :disabled="scope.row.status == 'PUTAWAY' ? true : false"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 2);
                }
              "
            >
              <el-option
                v-for="item in cityManager"
                :key="item.shopId"
                :label="item.shopName"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="地区公司康贝"
          prop="city_merchantNo"
          width="200"
        >
          <template slot-scope="scope">
            <el-select
              size="mini"
              :disabled="scope.row.status == 'PUTAWAY' ? true : false"
              v-model="scope.row.city_merchantNo"
              @visible-change="
                (val) => {
                  getListByShopIdFn(val, scope.row.city_shopId, 2);
                }
              "
            >
              <el-option
                v-for="(item, key) in listByShopId2"
                :key="key"
                :label="item.merchantNo"
                :value="item.merchantNo"
              >
                <span style="color: #8492a6; font-size: 13px">
                  康贝号: {{ item.merchantNo }}</span
                >
                <span> {{ item.merchantName }}</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="服务费金额" prop="city_amount" width="140">
          <template slot-scope="scope">
            <div class="unit-box">
              <span>
                <el-input
                  :disabled="
                    scope.row.city_shopName == '' ||
                    scope.row.city_shopName == null ||
                    scope.row.status == 'PUTAWAY'
                      ? true
                      : false
                  "
                  v-model="scope.row.city_amount"
                  style="width: 100px"
                  size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                >
                  <template slot="prefix">
                    <span
                      class="unitY"
                      :style="
                        scope.row.city_shopName == '' ||
                        scope.row.city_shopName == null ||
                        scope.row.status == 'PUTAWAY'
                          ? 'color:#8c8c8c'
                          : 'color:#606266'
                      "
                      >￥</span
                    >
                  </template>
                </el-input>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="省区公司名称"
          prop="serviceShopName"
          width="200"
        >
          <template slot-scope="scope">
            <el-select
              size="mini"
              :disabled="
                scope.row.status == 'PUTAWAY'  
                  ? true
                  : false
              "
              v-model="scope.row.serviceShopName"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 3);
                }
              "
            >
              <el-option
                v-for="item in provinceManager"
                :key="item.shopId"
                :label="item.shopName"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="省区公司康贝"
          prop="serviceMerchantNo"
          width="200"
        >
          <template slot-scope="scope">
            <el-select
              size="mini"
              :disabled="
                scope.row.status == 'PUTAWAY'  
                  ? true
                  : false
              "
              v-model="scope.row.serviceMerchantNo"
              @visible-change="
                (val) => {
                  getListByShopIdFn(val, scope.row.serviceShopId, 3);
                }
              "
            >
              <el-option
                v-for="(item, key) in listByShopId3"
                :key="key"
                :label="item.merchantNo"
                :value="item.merchantNo"
              >
                <span style="color: #8492a6; font-size: 13px">
                  康贝号: {{ item.merchantNo }}</span
                >
                <span> {{ item.merchantName }}</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          label="地区需转账省区"
          prop="serviceAmount"
          width="140"
        >
          <template slot-scope="scope">
            <div class="unit-box">
              <span>
                <el-input
                  :disabled="scope.row.status == 'PUTAWAY' ? true : false"
                  v-model="scope.row.serviceAmount"
                  style="width: 100px"
                  size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                >
                  <template slot="prefix">
                    <span
                      class="unitY"
                      :style="
                        scope.row.city_shopName == '' ||
                        scope.row.city_shopName == null ||
                        scope.row.status == 'PUTAWAY'
                          ? 'color:#8c8c8c'
                          : 'color:#606266'
                      "
                      >￥</span
                    >
                  </template>
                </el-input></span
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column label="省学术公司" prop="studyShopName" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              :disabled="
                scope.row.status == 'PUTAWAY'  
                  ? true
                  : false
              "
              v-model="scope.row.studyShopName"
              @change="
                (val) => {
                  reservationChange(val, scope.$index, 4);
                }
              "
            >
              <el-option
                v-for="item in provinceManager"
                :key="item.shopId"
                :label="item.shopName"
                :value="item"
              />
            </el-select>
          </template>
        </el-table-column>

        <el-table-column label="省学术康贝" prop="studyMerchantNo" width="200">
          <template slot-scope="scope">
            <el-select
              size="mini"
              :disabled="
                scope.row.status == 'PUTAWAY' 
                  ? true
                  : false
              "
              v-model="scope.row.studyMerchantNo"
              @visible-change="
                (val) => {
                  getListByShopIdFn(val, scope.row.studyShopId, 4);
                }
              "
            >
              <el-option
                v-for="(item, key) in listByShopId4"
                :key="key"
                :label="item.merchantNo"
                :value="item.merchantNo"
              >
                <span style="color: #8492a6; font-size: 13px">
                  康贝号: {{ item.merchantNo }}</span
                >
                <span> {{ item.merchantName }}</span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="省区需转学术" prop="studyAmount" width="140">
          <template slot-scope="scope">
            <div class="unit-box">
              <span>
                <el-input
                  :disabled="scope.row.status == 'PUTAWAY' ? true : false"
                  v-model="scope.row.studyAmount"
                  style="width: 100px"
                  size="mini"
                  oninput="value= value.match(/\d+(\.\d{0,2})?/) ? value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                >
                  <template slot="prefix">
                    <span
                      class="unitY"
                      :style="
                        scope.row.city_shopName == '' ||
                        scope.row.city_shopName == null ||
                        scope.row.status == 'PUTAWAY'
                          ? 'color:#8c8c8c'
                          : 'color:#606266'
                      "
                      >￥</span
                    >
                  </template>
                </el-input></span
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="上架状态"
          prop="status"
          align="center"
          fixed="right"
          min-width="105"
        >
          <template slot-scope="scope">
            <div class="siwtchView">
              <el-switch
                v-model="scope.row.status"
                active-value="PUTAWAY"
                inactive-value="SOLDOUT"
                active-color="#67c23a"
                inactive-color="#999"
                active-text="上架"
                inactive-text="下架"
                class="switchStyle"
                v-if="scope.row.productLineId"
                @change="changeStatus(scope.row, scope.$index)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <el-dialog
      title="选择单位"
      :visible.sync="dialogVisible"
      width="400px"
      :before-close="handleClose"
    >
      <div class="content-box">
        <span
          :class="unitKey == key ? 'unit active' : 'unit'"
          v-for="(item, key) in unitList"
          :key="key"
          @click="choseUnit(item, key)"
          >{{ item }}</span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="choseUnitSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 创建规则弹窗 -->
    <CreateRuleDialog 
      ref="createRuleDialogRef" 
      :cityArray="areaData" 
      :medicalArray="medicineManager" 
      @addSuccess="handleAddSuccess" 
    />
  </div>
</template>

<script>
import {
  getAreaCompany,
  productLineAreaPricesSelfBatch,
  getSelfPriceAndLedgerRule,
  skuUpdateStatus,
  getProductLineSkuList,
  getListByShopId,
} from "@/api/saleRule/productLine";
import CreateRuleDialog from "./CreateRuleDialog"
const dataLine = {
  productLineId: "",
  ledgerRulesId: "",
  shopId: "",
  shopName: "",
  price: "",
  amount: "",
  merchantNo: "", //医药公司 康贝号
  city_shopId: "",
  city_shopName: "",
  city_amount: "",
  city_merchantNo: "", //地区公司 康贝号
  city_ledgerRulesId: "",
  city_id: "",
  drug_ledgerRulesId: "",
  drug_id: "",
  serviceShopId: "",
  serviceShopName: "",
  serviceAmount: "",
  serviceMerchantNo: "", //省区公司 康贝号
  goodsSkuUnit: "盒",
  dbTransferAmount: 0,
  sbTransferAmount: 0,
  // provinceOrgName: this.provinceOrgName,
  // provinceOrgCode: this.provinceOrgCode,
  orgCode: "",
  orgName: "",
  status: "SOLDOUT", //@Schema(description = "状态：PUTAWAY.上架,SOLDOUT.下架")
  studyMerchantNo: "", //学术商户编号
  studyShopName: "", //学术店铺名称
  studyShopId: "", //学术商铺Id
  studyAmount: "", //学术金额
};
export default {
  components: {
    CreateRuleDialog,
  },
  props: {
    goodsId: {
      type: String,
      default() {
        return null;
      },
    },
    goodsName: {
      type: String,
      default() {
        return "";
      },
    },
    dfcData: {
      type: Array,
      default() {
        return [];
      },
    }, // 列表数据
    unitList: {
      type: Array,
      default() {
        return [];
      },
    }, // 单位数据
  },
  data() {
    return {
      kbSwitchFlag: 0, //康贝分流开关:0分流1不分流（指定账户）
      formTool: {},
      loading: false,
      dialogVisible: false,
      provinceOrgCode: "", // 省办orgCode /取的weight字段
      provinceOrgName: "湖南",
      areaListArr: [],
      areaData: [],
      medicineManager: [],
      cityManager: [],
      provinceManager: [],
      goodsSkuUnit: "盒",
      unitKey: 0,
      companyList: [], //医药公司名称
      orgCodeList: [], //区域code集合
      deatilData: [], //详情数据
      listByShopId: [],
      listByShopId2: [], //地区公司康贝
      listByShopId3: [], //省区区公司康贝
      listByShopId4: [], //省学术康贝
    };
  },
  created() {},
  //   @Schema(description = "状态：PUTAWAY.上架,SOLDOUT.下架")   // private String status;

  methods: {
    //创建规则
    createLedgerRules() {
      this.$refs.createRuleDialogRef.publicOpen();
    },
    // 根据店铺获取已有康贝号列表
    getListByShopIdFn(val, shopId, type) { 
      if (!shopId) { 
        return;
      }
      let params = {
        shopId: shopId,
      };
      getListByShopId(params).then((res) => {
        if (res) {
          if (type == 1) {
            this.listByShopId = res;
          }
          if (type == 2) {
            this.listByShopId2 = res;
          }
          if (type == 3) {
            this.listByShopId3 = res;
          }
          if (type == 4) {
            this.listByShopId4 = res;
          }
        }
      });
    },
    init(provinceOrgName) {
      if (provinceOrgName) {
        this.provinceOrgName = provinceOrgName;
        this.initAreaData();
      } else {
        this.initAreaData();
      }
    },
    // // 初始化省市区域数据

    initAreaData() {
      this.orgCodeList = [];
      this.areaList = this.dfcData; // 区域list 换成组织list 
      // 1取出对应省办 地办数据
      this.areaListArr = [];
      this.areaList.map((item) => {
        if (item.name == this.provinceOrgName) {
          this.provinceOrgCode = item.weight;
          this.areaListArr = item.children || [];
        }
      });

      // 2市区级数据 orgCodeList
      this.areaListArr.map((item) => {
        this.orgCodeList.push(item.weight);
      });
      this.orgCodeList.push(this.provinceOrgCode);
      this.getAreaCompanyFn(); // 统一分账获取省地办
    },

    // 有sku才可以上架
    initData() {
      // 区域list // 初始化省市区 表格内显示的静态数据
      this.getProductLineSkuList();
      this.loading = false;
    },

    // 获取 商品skulist
    getProductLineSkuList(shopId, type, index) {
      let params = {
        goodsId: this.goodsId, //必传
        orgCodeSet: this.orgCodeList, //必传
      };
      getProductLineSkuList(params)
        .then((res) => {
          let resp = res;
          let areaData = []; 
          // 初始默认的市区地域列表
          this.areaListArr.map((k) => {
            let newData = { ...dataLine };
            newData.orgCode = k.weight;
            newData.orgName = k.name;
            newData.provinceOrgName = this.provinceOrgName;
            areaData.push(newData);
          });
          let szObj = { ...dataLine };
          szObj.orgName = "省直";
          szObj.orgCode = this.provinceOrgCode;
          areaData.unshift(szObj); 
          // areaData 把对应的地域上的产品线挂载到当前的地域上
          for (let i = 0; i < areaData.length; i++) {
            let lineArr = [];
            for (let e of resp) {
              // console.log(e)
              if (areaData[i].orgCode == e.orgCode) {
                let newData2 = { ...dataLine };
                newData2.orgCode = e.orgCode;
                newData2.productLineId = e.productLineId;
                newData2.shopId = e.shopId;
                newData2.shopName = e.shopName;
                newData2.goodsSkuPriceId = e.goodsSkuPriceId;
                newData2.orgName = areaData[i].orgName;
                newData2.provinceOrgName = this.provinceOrgName;
                lineArr.push(newData2);
              }
            }
            if (lineArr.length > 0) {
              areaData.splice(i, 1, lineArr);
            }
          }
          // console.log(areaData, '---areaData111')
          let arrFlat = this.multiarr(areaData);

          if (arrFlat == 2) {
            areaData = areaData.flat(1); //拉平1层，二维数组转1维数组
          }

          this.areaData = areaData;
          this.mapAreaData();
        })
        .catch((err) => {});
    },

    // 判断数组是几维数组
    multiarr(arr) {
      let a = 1;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i] instanceof Array) {
          a++;
          arr = arr[i];
          this.multiarr(arr);
        }
      }
      return a;
    },

    mapAreaData() {
      this.areaData.map((item) => { 
        // cityManager--   统一分账获取省地办 接口返回的 地办数据

        this.cityManager.map((e) => {
          //  地办初始默认选择--匹配 属于当前地办的公司
          if (item.orgCode == e.areaCode) {
            item.city_shopId = e.shopId;
            item.city_shopName = e.shopName;
            item.city_merchantNo = e.merchantNo;
          }
        });

        item.city_includeService = true; //默认true 市级没公司就选false
        let index = 0;
        // medicineManager  统一分账获取省地办 接口返回的 医药公司数据
        // shopId 取省医药公司的shopId 

        for (let k = 0; k < this.medicineManager.length; k++) {
          if (item.shopId == this.medicineManager[k].shopId) {
            item.merchantNo = this.medicineManager[k].merchantNo;
          }
        }

        // provinceManager  统一分账获取省地办 接口返回的 省办公司数据
        if (this.provinceManager.length > 0) {
          item.serviceShopId = this.provinceManager[index].shopId;
          item.serviceShopName = this.provinceManager[index].shopName;
          item.serviceMerchantNo = this.provinceManager[index].merchantNo;
        }

        // 查询到的详情数据匹配到组织地级数据list
        if (this.deatilData.length > 0) {
          this.deatilData.map((e) => {
            if (
              item.orgCode == e.orgCode &&
              item.productLineId == e.productLineId
            ) {
              item.ledgerRulesId = e.ledgerRulesId;
              item.productLineId = e.productLineId;
              item.goodsId = e.goodsId;
              item.goodsName = e.goodsName;
              item.goodsSkuPriceId = e.goodsSkuPriceId;
              item.goodsSkuUnit = e.goodsSkuUnit;
              item.price = e.price; //销售定价
              item.status = e.status;

              //医药公司
              item.amount = e.drugLedgerRules.amount;
              item.drug_id = e.drugLedgerRules.id;
              item.drug_ledgerRulesId = e.drugLedgerRules.ledgerRulesId;
              item.merchantNo = e.drugLedgerRules.merchantNo;
              item.shopId = e.drugLedgerRules.shopId;
              item.shopName = e.drugLedgerRules.shopName;

              //地区公司
              item.city_id = e.cityLedgerRules.id;
              item.city_ledgerRulesId = e.cityLedgerRules.ledgerRulesId;
              item.city_merchantNo = e.cityLedgerRules.merchantNo;
              item.city_amount = e.cityLedgerRules.amount;
              item.city_shopId = e.cityLedgerRules.shopId;
              item.city_shopName = e.cityLedgerRules.shopName;
              item.city_standbyEnable = e.cityLedgerRules.standbyEnable;

              //地区需转省区公司
              item.serviceAmount = e.cityLedgerRules.serviceAmount;
              item.serviceMerchantNo = e.cityLedgerRules.serviceMerchantNo;
              item.serviceShopId = e.cityLedgerRules.serviceShopId;
              item.serviceShopName = e.cityLedgerRules.serviceShopName;
              item.dbTransferAmount = e.cityLedgerRules.dbTransferAmount;
              item.sbTransferAmount = e.cityLedgerRules.sbTransferAmount;

              //省区学术
              item.studyAmount = e.cityLedgerRules.studyAmount;
              item.studyMerchantNo = e.cityLedgerRules.studyMerchantNo;
              item.studyShopId = e.cityLedgerRules.studyShopId;
              item.studyShopName = e.cityLedgerRules.studyShopName;
            }
          });
        }

        // console.log(this.provinceOrgName,'---this.provinceOrgName')
      });

      if (this.medicineManager.length == 0) {
        this.$message({
          message: `请先配置合作医药公司！`,
          type: "info",
        });
        return false;
      }
      // shopId 取省医药公司的shopId 
    },

    // 统一分账获取省地办
    getAreaCompanyFn() {
      this.loading = true;
      let params = {
        orgCode: this.provinceOrgCode, // provinceOrgCode 省区id
      };
      getAreaCompany(params).then((res) => {
        // console.log(res,'----res')
        this.kbSwitchFlag = res.kbSwitchFlag; // 康贝分流开关:0分流1不分流
        this.cityManager = res.cityManager; //市级 公司 列表
        this.provinceManager = res.provinceManager; // 省级公司列表
        this.medicineManager = res.medicineManager; //医药公司列表
        setTimeout(() => {
          this.getSelfPriceAndLedgerRuleFn();
        }, 500);
      });
    },

    // 获取分账管理列表 获取详情数据列表
    getSelfPriceAndLedgerRuleFn() {
      if (this.goodsId == "") return;
      let params = {
        goodsId: this.goodsId,
        orgCodeSet: this.orgCodeList,
      };
      getSelfPriceAndLedgerRule(params).then((res) => {
        if (res) {
          this.deatilData = res;
        }
        this.initData();
      });
    },

    // goodsSkuPriceId
    changeStatus(row, index) {
      if (row.status != "PUTAWAY") {
        this.$confirm("此操作将下架商品, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.updateStatus(row, 1);
          })
          .catch(() => {
            this.areaData[index].status = "PUTAWAY";
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        let flag = this.validateForm(row);
        if (!flag) {
          this.areaData[index].status = "SOLDOUT";
        } else {
          this.updateStatus(row, 2);
        }
      }
    },

    updateStatus(row, type) {
      let params = {
        skuId: row.goodsSkuPriceId,
        status: row.status == "PUTAWAY" ? 1 : 2,
      };
      skuUpdateStatus(params).then((res) => {
        if (res.code == 1) {
          this.$message({
            type: "error",
            message: res.msg,
          });
        } else {
          this.$message({
            message: `修改成功！`,
            type: "success",
          });
        }
      });
    },

    // 合并第一列单元格
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
    },

    // 点击选择单位choseUnit
    choseUnit(e, key) {
      // console.log(e, "e");  console.log(key, "key");
      this.unitKey = key;
      this.goodsSkuUnit = e;
    },

    // 确认选择单位
    choseUnitSure() {
      this.areaData[this.currentRowIndex].goodsSkuUnit = this.goodsSkuUnit;
      this.dialogVisible = false;
    },

    // 设置下拉选择 值
    reservationChange(val, index, type) {
      //这样就可以传递自定义的参数了
      // console.log(val, "--val--", index, "--index--", type, "type");
      if (type == 1) {
        this.areaData[index].shopName = val.shopName;
        this.areaData[index].shopId = val.shopId;
        this.areaData[index].merchantNo = val.merchantNo;
        // 调用sku接口
        this.getProductLineSkuList(val.shopId, "select", index);
      }
      if (type == 2) {
        this.areaData[index].city_shopName = val.shopName;
        this.areaData[index].city_shopId = val.shopId;
        this.areaData[index].city_merchantNo = val.merchantNo;
      }
      if (type == 3) {
        this.areaData[index].serviceShopName = val.shopName;
        this.areaData[index].serviceShopId = val.shopId;
        this.areaData[index].serviceMerchantNo = val.merchantNo;
      }
      if (type == 4) {
        this.areaData[index].studyShopName = val.shopName;
        this.areaData[index].studyShopId = val.shopId;
        this.areaData[index].studyMerchantNo = val.merchantNo; 
      }
    },

    objectSpanMethod({ row, column, rowIndex, columnIndex }, value) {
      if (columnIndex === 0) {
        if (rowIndex === 0) {
          return {
            rowspan: value.length,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      } else {
        //定义需要合并的列字段，有哪些列需要合并，就自定义添加字段即可
        const fields = ["orgName"];
        // 当前行的数据
        const cellValue = row[column.property];
        // 判断只合并定义字段的列数据
        if (cellValue && fields.includes(column.property)) {
          const prevRow = this.areaData[rowIndex - 1]; //上一行数据
          let nextRow = this.areaData[rowIndex + 1]; //下一行数据
          // 当上一行的数据等于当前行数据时，当前行单元格隐藏
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 };
          } else {
            // 反之，则循环判断若下一行数据等于当前行数据，则当前行开始进行合并单元格
            let countRowspan = 1; //用于合并计数多少单元格
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = this.areaData[++countRowspan + rowIndex];
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 };
            }
          }
        }
      }
    },

    // 打开选择单位弹窗
    openDaliog(row, rowIndex) {
      this.dialogVisible = true;
      this.currentRowIndex = rowIndex;
    },

    // 全局应用设置价格数据
    save(from) {
      // console.log("from", from);
      // 全局设置 循环填充数据
      for (let item of this.areaData) {
        if (item.status == "PUTAWAY" || !item.goodsSkuPriceId) continue; // 如果本条数据是上架状态/ 或者本条数据没有sku，本条数据不做修改
        from.price ? (item.price = parseFloat(from.price)) : (item.price = ""); //销售定价
        from.amount
          ? (item.amount = parseFloat(from.amount))
          : (item.amount = ""); //销售金额
        from.serviceAmount
          ? (item.serviceAmount = parseFloat(from.serviceAmount))
          : (item.serviceAmount = ""); //地区需转账省区

        // console.log(item.city_shopName,'item.city_shopName--')
        from.city_amount && item.city_shopName
          ? (item.city_amount = parseFloat(from.city_amount))
          : ((item.city_amount = ""), (item.serviceAmount = from.city_amount)); //服务费用

        from.goodsSkuUnit
          ? (item.goodsSkuUnit = from.goodsSkuUnit)
          : (item.goodsSkuUnit = "");

        from.studyAmount
          ? (item.studyAmount = from.studyAmount)
          : (item.studyAmount = null);
      }
      this.$forceUpdate();
    },

    validateForm(item) {
      // console.log(item)

      if (!item.price || parseFloat(item.price) == 0) {
        this.$message({
          message: `【${item.orgName}】"销售定价"必须填写 ！`,
          type: "warning",
        });
        return false;
      }

      if (!item.amount || parseFloat(item.amount) == 0) {
        this.$message({
          message: `【${item.orgName}】"销售金额"必须填写！`,
          type: "warning",
        });
        return false;
      }

      if (
        (!item.city_amount || parseFloat(item.city_amount) == 0) &&
        item.city_shopName
      ) {
        this.$message({
          message: `【${item.orgName}】"服务费金额"必须填写！`,
          type: "warning",
        });
        return false;
      }

      if (!item.serviceAmount || parseFloat(item.serviceAmount) == 0) {
        this.$message({
          message: `【${item.orgName}】"地区需转账省区"必须填写！`,
          type: "warning",
        });
        return false;
      }

      console.log(item.serviceAmount, "--item.serviceAmount ");

      if (!item.merchantNo || !item.merchantNo) {
        this.$message({
          message: `【${item.orgName}】【${item.shopName}】 医药公司康贝号为空！`,
          type: "warning",
        });
        return false;
      }

      if (
        item.city_shopName != null &&
        item.city_shopName != "" &&
        (item.city_merchantNo == null || item.city_merchantNo == "")
      ) {
        this.$message({
          message: `【${item.orgName}】【${item.shopName}】地区公司康贝号为空！`,
          type: "warning",
        });
        return false;
      }

      if (!item.serviceMerchantNo) {
        this.$message({
          message: `【${item.orgName}】【${item.shopName}】省区公司康贝号为空！`,
          type: "warning",
        });
        return false;
      }

      if (item.studyAmount && !item.studyShopName) {
          this.$message({
            message: `【${item.orgName}】【${item.shopName}】省学术公司为空！`,
            type: "warning",
          });
          return;
        }

      if (item.studyAmount && !item.studyMerchantNo) {
        this.$message({
          message: `【${item.orgName}】【${item.shopName}】省学术康贝为空！`,
          type: "warning",
        });
        return false;
      } 

      if (
        item.status != "PUTAWAY" &&
        item.serviceAmount &&
        item.studyAmount &&
        item.studyAmount > item.serviceAmount
      ) {
        this.$message({
          message: `【${item.orgName} "省区转学术" 必须小于等于 "地区需转账省区"！`,
          type: "warning",
        });
        return false;
      }

      return true;
    },
    // 提交数据
    submit(from) {
      let params = [];
      for (let item of this.areaData) {
        // 如果本条数据全部是空 中断本次循环 此条数据不进入数据池
        if (
          !item.price &&
          !item.amount &&
          !item.city_amount &&
          !item.serviceAmount
        ) {
          continue;
        }

        if (!item.city_shopName) {
          item.city_includeService = false;
        }
        let flag = this.validateForm(item);
        // console.log(flag, "flag");
        if (!flag) return;

        item.city_amount
          ? (item.city_amount = parseFloat(item.city_amount))
          : (item.city_amount = "");
        item.price ? (item.price = parseFloat(item.price)) : (item.price = "");
        item.amount
          ? (item.amount = parseFloat(item.amount))
          : (item.amount = "");
        item.serviceAmount
          ? (item.serviceAmount = parseFloat(item.serviceAmount))
          : (item.serviceAmount = "");

        const {
          goodsSkuUnit,
          orgName,
          orgCode,
          price,
          shopId,
          shopName,
          merchantNo,
          serviceShopId,
          serviceShopName,
          serviceAmount,
          serviceMerchantNo,
          goodsSkuPriceId,
          amount,
          productLineId,
          ledgerRulesId,
          dbTransferAmount,
          sbTransferAmount,
          studyAmount,
          studyMerchantNo,
          studyShopId,
          studyShopName,
        } = item;
        const { goodsId, goodsName } = this;
        // 拼装给后端的数据
        let obj = {
          goodsId,
          goodsName,
          goodsSkuUnit,
          price,
        };
        obj.status = item.status;
        obj.id = item.id;
        obj.goodsSkuPriceId = goodsSkuPriceId;
        obj.productLineId = productLineId;
        obj.ledgerRulesId = ledgerRulesId;
        obj.orgCode = orgCode; //地办组织code
        obj.orgName = orgName; //地办组织名称
        obj.kbSwitchFlag = this.kbSwitchFlag;
        obj.drugLedgerRules = {
          shopId,
          shopName,
          merchantNo,
          amount, 
        };
        obj.drugLedgerRules.costType = "DETAIL";
        obj.drugLedgerRules.includeService = false;
        obj.drugLedgerRules.id = item.drug_id;
        obj.drugLedgerRules.ledgerRulesId = item.drug_ledgerRulesId;

        obj.cityLedgerRules = {
          id: item.city_id || null,
          ledgerRulesId: item.city_ledgerRulesId || null,
          amount: item.city_amount || null,
          merchantNo: item.city_merchantNo,
          shopId: item.city_shopId,
          shopName: item.city_shopName,
          includeService: item.city_shopName ? true : false,
          costType: "SERVICE",
        };
        obj.cityLedgerRules = {
          serviceShopId,
          serviceShopName,
          serviceAmount,
          serviceMerchantNo,
          dbTransferAmount,
          sbTransferAmount,
          studyAmount,
          studyMerchantNo,
          studyShopId,
          studyShopName,
          ...obj.cityLedgerRules,
        };

        params.push(obj);
      }
      if (params.length == 0) {
        this.$message({
          message: `请设置分账！`,
          type: "warning",
        });
        return;
      }
      // console.log(params, "params--");
      this.productLineAreaPrices(params);
    },

    productLineAreaPrices(params) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      productLineAreaPricesSelfBatch(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message({
              message: res.msg,
              type: "error",
            });
          } else {
            this.$message({
              message: `提交成功！`,
              type: "success",
            });
          }
          setTimeout(() => {
            loading.close();
            this.init(this.provinceOrgName);
          }, 2000);
        })
        .catch((err) => {
          setTimeout(() => {
            loading.close();
          }, 2000);
        });
    },
    clearTips(row, index) {
      console.log(row);

      this.areaData[index].city_shopId = "";
      this.areaData[index].city_shopName = "";
      this.areaData[index].city_amount = "";
      // console.log( this.areaData[index],'areaData1')
      if (row.city_standbyEnable == 1) {
        this.$message.warning("备用分账规则里面有地办在用");
      }
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleAddSuccess() {
      this.$emit("addSuccess");
    }
  },
};
</script>

<style lang="scss">
@import "../styles/index.scss";
.unitY {
  line-height: 32px;
}
</style>
